import {Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, 
    Grid,
    Button, TextField} from "@mui/material"
import Transaction from "./Transaction";
import dayjs from 'dayjs';
import React from "react";
// 
import { getTransactions, saveTransactions } from "./connect_data";
import CryptoJS from "crypto-js";

const CloudDialog = (props) => {
    const [URL, setURL] = React.useState("https://us-east-1.aws.data.mongodb-api.com/app/dfin_app-rnwhu")
    const [userName, setUserName] = React.useState("sample")
    const [pin, setPin] = React.useState("1234")

    const getFromCloud_callback = (data) => {
        var newTransaction = []
        console.log("getFromCloud_callback: data=", data)
        if(data==null) {
            alert("Error loading data from cloud. Try different username of PIN")
            return
        }
        const trs = data[0]
        const n = trs["comment"].length
        for(let i=0; i<n; ++i) {
            newTransaction.push(new Transaction(
                dayjs(new Date(trs["date"][i])), 
                trs["comment"][i], 
                trs["sum"][i]
            ))
        };
        var favs = trs["favs"];
        if(favs === undefined) {
            favs = []
        }
        props.handleLoad(newTransaction, favs)
    }

    const getFromCloud = ()  => {
        console.log("getFromCloud: Cloud clicked");
        var warning = "Are you sure you want to LOAD data set \""+userName+"\"\n"
        warning = warning+"\n\nThis operation will overwrite your current dataset and cannot be undone!!!"
        if(window.confirm(warning)==true) {
            var cryptedName = stab_crypto(userName, pin)
            console.log("crypted name is ", cryptedName)
            getTransactions(cryptedName, getFromCloud_callback);
        }
    }

    const stab_crypto = (message, key) => {
        const keyutf = CryptoJS.enc.Utf8.parse(key);
        const iv = CryptoJS.enc.Base64.parse(key);
        const enc = CryptoJS.AES.encrypt(message, keyutf, { iv: iv });
        const encStr = enc.toString();
        return encStr;
    }

    const urlField = <TextField  label = "URL" value={URL} onChange={(e) => setURL(e.target.value)} fullWidth/>
    const loadButton = <Button onClick={getFromCloud} fullWidth>Load</Button>
    const nameField = <TextField  label = "Name" value={userName} 
        onChange={(e) => setUserName(e.target.value)} fullWidth/>
   
    const saveButton = <Button onClick={() => {
        let warning="Are you sure that you want to SAVE data set with name \""+userName+"\" to cloud?"
        warning = warning+"\n\nThis operation cannot be undone!!!"
        if(window.confirm(warning)==true) {
            var cryptedName = stab_crypto(userName, pin)
            console.log("saving with name ", cryptedName)
            props.handleSave(cryptedName)
        }
     }}
     fullWidth>Save</Button>
   
     const pinField = <TextField  label = "PIN" value={pin} 
        onChange={(e) => setPin(e.target.value)} fullWidth/>
     const closeButton = <Button onClick={props.handleClose} fullWidth>Close</Button> 

    return <Dialog open={props.opened} onClose={props.handleClose}>
        <DialogTitle style={{fontWeight:"bold"}}>Cloud Dialog</DialogTitle>
        <Grid container spacing={2}>
            <Grid item xs={1}/>
            <Grid item xs={8}>{nameField}</Grid>
            <Grid item xs={3}>{loadButton}</Grid>

            <Grid item xs={1}/>
            <Grid item xs={8}>{pinField}</Grid>
            <Grid item xs={3}>{saveButton}</Grid>
            
            <Grid item xs={1}/>
            <Grid item xs={8}></Grid>
            <Grid item xs={3}>{closeButton}</Grid>
        </Grid>
        <DialogContent>
             
             
        </DialogContent>
        <DialogActions>
                 
                 
                 
                 
        </DialogActions>
        </Dialog>
}

export default CloudDialog

